import type { TUserRole } from '@/shared/types/common';

export const userRoles: TUserRole[] = ['admin', 'user'];

export const userRoleTitles: Record<TUserRole, string> = {
  admin: 'Админ',
  user: 'Пользователь',
  operator: 'Оператор'
};

type Entries<T> = {
  [K in keyof T]: [K, T[K]]
}[keyof T][];

export const typedEntries = <T extends object>(obj: T) => {
  return Object.entries(obj) as Entries<T>;
};
